import { render, staticRenderFns } from "./HeadingImageSectionModule.vue?vue&type=template&id=8d489844&"
import script from "./HeadingImageSectionModule.vue?vue&type=script&lang=js&"
export * from "./HeadingImageSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports